import { render, staticRenderFns } from "./UserGuides.vue?vue&type=template&id=b77ba4fc&scoped=true&"
import script from "./UserGuides.vue?vue&type=script&lang=js&"
export * from "./UserGuides.vue?vue&type=script&lang=js&"
import style0 from "./UserGuides.vue?vue&type=style&index=0&id=b77ba4fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ba4fc",
  null
  
)

export default component.exports